/**
 * #1124 report completeness: the Copy report's context, read once when Copy
 * is clicked. Every reading here already exists; this opens no sampler, poll,
 * fetch or storage write.
 */
import { getFeedHealth, statusFeedLabel } from '@/hooks/useHydra';
import { getBookSourceAgesForGroup, useMarketStore } from '@/stores/marketStore';
import { useBuildUpdateStore } from '@/stores/buildUpdateStore';
import { viewGroupOf } from '@/lib/telemetry/viewGroups';
import type { ReportContextReading } from '@/lib/telemetry/pressureReport';
import type { ReportView, TransportCounts } from '@/lib/telemetry/reportContext';

function transportCounts(): TransportCounts {
  const counts: TransportCounts = { shared: 0, direct: 0, connecting: 0, total: 0 };
  for (const h of getFeedHealth()) {
    counts[h.transport] += 1;
    counts.total += 1;
  }
  return counts;
}

export function collectReportContext(view: ReportView, now = Date.now()): ReportContextReading {
  const market = useMarketStore.getState();
  // Source age is read for a single-game view only, over the books that view asked for.
  const ages = view.game == null ? null : getBookSourceAgesForGroup(viewGroupOf, view.page);
  return {
    host: typeof location === 'undefined' ? '' : location.host,
    served: useBuildUpdateStore.getState().latest,
    transport: transportCounts(),
    liveness: { feed: statusFeedLabel(), connected: market.connected, lastDataMs: market.lastMessageMs, lastKeepaliveMs: market.getLastKeepaliveMs(), now },
    sourceAge: ages == null ? null : { group: view.page, ...ages },
  };
}
